import { createAction } from "@reduxjs/toolkit";

export const addCart = createAction("ADD_CART");
export const getCart = createAction("GET_CART");
export const removeCart = createAction("REMOVE_CART");
